export default __webpack_public_path__ + "static/media/Pistol_7.d04294d1.png";